/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S4_HeadingInputs */

const tr_iletisim_s4_heading = /** @type {(inputs: Iletisim_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faturalandırma`)
};

const en_iletisim_s4_heading = /** @type {(inputs: Iletisim_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const de_iletisim_s4_heading = /** @type {(inputs: Iletisim_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungsstellung`)
};

const ru_iletisim_s4_heading = /** @type {(inputs: Iletisim_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выставление счетов`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Iletisim_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s4_heading = /** @type {((inputs?: Iletisim_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s4_heading(inputs)
	if (locale === "de") return de_iletisim_s4_heading(inputs)
	if (locale === "ru") return ru_iletisim_s4_heading(inputs)
	return tr_iletisim_s4_heading(inputs)
});